import { useMemo, useState } from 'react'
import { useParams } from '@tanstack/react-router'
import { useGetPracTestStat } from '@/services/pracTestService'
import { useModulesStore } from '@/stores/useModulesStore'
import SummaryStats from '@/components/ui/SummaryStats/summary-stats'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import BreadScrum from '@/components/BreadScrum'
import PageTitle from '@/components/PageTitle'
import { Main } from '@/components/layout/main'
import MarkIcon from '@/components/svg/MarkIcon'
import MockExamTable from './components/MockExamTable'
import PracticeTestTable from './components/PracticeTestTable'
import { TestTabs } from './constants'

export default function ModuleTestDetail() {
  const { moduleId } = useParams({ strict: false })
  const [testTab, setTestTab] = useState(TestTabs.prac_test)
  const { selectedModule } = useModulesStore()

  const { pracTestStat, isLoadingPracTestStat } = useGetPracTestStat(
    moduleId ?? ''
  )

  const statData = useMemo(() => {
    return [
      {
        title: 'Practice Test Attempts',
        value: String(pracTestStat?.total_practice_tests ?? 'N/A'),
        icon: <MarkIcon size={48} />,
      },
      {
        title: 'Average Practice Test Score',
        value: String(pracTestStat?.avg_pt_marks ?? 'N/A'),
        icon: <MarkIcon size={48} />,
        valueSuffix: pracTestStat?.avg_pt_marks === null ? '' : '%',
        showTooltip: true,
      },
      {
        title: 'Mock Exam Attempts',
        value: String(pracTestStat?.total_mock_exams ?? 'N/A'),
        icon: <MarkIcon size={48} />,
      },
      {
        title: 'Average Mock Exam Score',
        value: String(pracTestStat?.avg_mock_exam_marks ?? 'N/A'),
        icon: <MarkIcon size={48} />,
        valueSuffix: pracTestStat?.avg_mock_exam_marks === null ? '' : '%',
        showTooltip: true,
      },
    ]
  }, [pracTestStat])

  return (
    <Main>
      <BreadScrum
        breadcrumbs={[
          { link: '/test/', label: 'Test management' },
          { link: '', label: selectedModule?.name ?? '' },
        ]}
      />
      <PageTitle title={selectedModule?.name ?? ''} />
      <div className='flex w-full flex-col items-start gap-4 pt-4'>
        <SummaryStats
          data={statData}
          isloading={isLoadingPracTestStat}
          columns={'4'}
          gap={'12px'}
          width={'100%'}
        />
        <Tabs
          defaultValue={TestTabs.prac_test}
          className='mt-2 w-full flex-col gap-4'
        >
          <TabsList className='gap-3 bg-transparent'>
            {Object.values(TestTabs).map((item: string) => (
              <TabsTrigger
                value={item}
                key={item}
                className='p-1 text-base text-[#667085]'
                onClick={() => setTestTab(item)}
              >
                {item}
              </TabsTrigger>
            ))}
          </TabsList>
          <TabsContent value={TestTabs.mock_exam}>
            <MockExamTable testType={testTab} moduleId={moduleId as string} />
          </TabsContent>
          <TabsContent value={TestTabs.prac_test}>
            <PracticeTestTable
              testType={testTab}
              moduleId={moduleId as string}
            />
          </TabsContent>
        </Tabs>
      </div>
    </Main>
  )
}
